import React from 'react';
import { ShopArray } from '../../fetch/fetchInbound';
import { useGetShopArray } from '../../hooks/useGetShopArray';
import ShopArrayComboBox from './ShopArrayComboBox';

export function EditShops({
  shopList,
  addShopMethod,
}: {
  shopList: ShopArray[];
  addShopMethod: (shop: ShopArray[]) => void;
}): JSX.Element {
  const { shopArrayList, isLoading } = useGetShopArray();

  return (
    <>
      {!isLoading && (
        <ShopArrayComboBox
          placeHolderText={'Shop selection'}
          shopList={shopList}
          shopArrayList={shopArrayList}
          multiple
          addShopMethod={addShopMethod}
        />
      )}
    </>
  );
}
